import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Sidebar from './Sidebar';
import MainContent from './MainContent';
import { Demo } from '../types/Demo';

const Dashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'demos' | 'create'>('demos');
  const [demos, setDemos] = useState<Demo[]>([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefreshDemos = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <Row className="h-100">
      <Col md={3} className="p-2">
        <Sidebar 
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          demos={demos}
          onRefreshDemos={handleRefreshDemos}
        />
      </Col>
      <Col md={9} className="p-2">
        <MainContent 
          activeTab={activeTab}
          demos={demos}
          setDemos={setDemos}
          refreshTrigger={refreshTrigger}
        />
      </Col>
    </Row>
  );
};

export default Dashboard;